import gql from 'graphql-tag';

export const fileOperation = gql`
  fragment FileOperation on FileOperation {
    id
    businessId
    status
    type
    processedCount
    totalCount
    createdAt
    updatedAt
    name
    userId
  }
`;
